module.exports = __webpack_public_path__ + "images/logo-black_369c0cc34f310cd15ff961277d2cd8a6.png";